<div class="icons-wrapper d-flex">
  <span
    *ngIf="
      showNewIcon() &&
      (product.isNew || product?.icons?.hasNewIconByDeliveryMonth)
    "
    class="font-weight-bold mr-2 text-new"
  >
    {{ newText }}
  </span>

  <div *ngIf="showPopularityIcon && product?.icons?.hasPopularityIcon">
    <fa-icon
      [atxTooltip]="popularityIconTooltip"
      [icon]="['fas', 'fire-flame-curved']"
      class="popularity-icon text-primary mr-2"
    ></fa-icon>
  </div>

  <div
    class="gender-icon d-flex align-items-center"
    [ngClass]="genderIconClassName"
    *ngIf="genderIconEntry && showGenderIcon"
  >
    @if (genderIcon) {
    <fa-icon
      class="p-card-icon mr-1"
      [atxTooltip]="genderIconTooltipText ?? ''"
      [icon]="genderIcon"
    ></fa-icon>
    }
    <span>{{ genderIconText }}</span>
  </div>

  <ng-container *ngIf="isMraShown">
    <span
      class="font-weight-bold mr-2 d-inline-block mra-icon"
      i18n="Product card|MRA text@@mraIconText"
      >MRA</span
    >
  </ng-container>

  <atx-custom-icon
    *ngIf="product.icons?.hasMarketingSupportIcon"
    [atxTooltip]="marketingSupportIconText"
    [tooltipPlacement]="Placement.TOP"
    icon="marketing-support"
    [path]="spritesPaths.PRODUCT"
    class="text-body mr-2"
  ></atx-custom-icon>
  <span
    class="p-card-icon font-weight-bold mr-2 d-inline-block p-card-icon-noos"
    *ngIf="product.icons?.hasGlobalNoosIcon"
  >
    <atx-custom-icon
      icon="noos"
      [path]="spritesPaths.PRODUCT"
    ></atx-custom-icon>
    {{ noosText }}
  </span>
  <ng-container *ngIf="showEstimatedDeliveryDate">
    <span
      *ngIf="
        product.earliestDeliveryDate ?? product.earliestAvailableDate ?? ''
          | utcDate: dateFormat as earliestDeliveryDate
      "
      class="earliest-delivery-date-icon font-weight-bold text-uppercase d-flex align-items-center p-card-icon mr-2"
      [atxTooltip]="productCardTooltip"
    >
      <fa-icon [icon]="['fas', 'truck']" flip="horizontal"></fa-icon>
      {{ earliestDeliveryDate }}
    </span>
  </ng-container>
</div>
